// extracted by mini-css-extract-plugin
export default {"button":"MK2NdU","disabled":"NPXqd2","withBorder":"ew8BFM","withBorderBottom":"ZeeiLH","style-gold-50":"cyPLFl","style-black":"xj8fg4"};